import styled from "styled-components";

export const OrderTypeSelectorStyled = styled.div``;

export const OrderTypeSelectorToggleStyled = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;

    background: rgba(129, 146, 228, 0.1);
    border-radius: 16px;

    padding: 0 16px;
`;

export const OrderTypeSelectorToggleTitleStyled = styled.div`
    color: rgba(255, 255, 255, 0.6);
    padding: 12px 0;
`;

export const OrderTypeSelectorToggleValueStyled = styled.div`
    font-weight: 600;
    padding: 12px 0;
`;

export const OrderTypeSelectorHeaderStyled = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 16px;
`;

export const OrderTypeSelectorListStyled = styled.div`
    background: rgba(129, 146, 228, 0.05);
    border-radius: 16px;
    padding: 4px;
`;

export const OrderTypeSelectorListItemStyled = styled.div.attrs(props => ({
    className: `${props.selected ?
        'selected' :
        ''}`
}))`
    padding: 12px;
    border-radius: 12px;

    &.selected,
    &:hover {
        background: rgba(129, 146, 228, 0.1);
    }
`;
